module.exports = __webpack_public_path__ + "static/media/autoscout.992ed03f.png";